
import axios from "axios"
import ApiStore from './ApiStore'


export class CalendarStore extends ApiStore{
  
  updateDeliveryDate(postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/calendar/deliveringdate/',postData)
      .then(function (response) {
        console.log(response.data)
        let result = response.data
        if (result.status === 'OK')
          completeFunc(result)
        else
          errorFunc(result)
      })
      .catch(function (error) {
        console.log('error',error);
        errorFunc({ status: 'error', desc: error });
      })
  }

  updateNotificationNoticeDate(type,bf_notification_id,postData,completeFunc,errorFunc){
    console.log('postData',postData)
    axios.post('/calendar/notification_noticedate/'+type+'/'+bf_notification_id,postData)
      .then(function (response) {
        console.log(response.data)
        let result = response.data
        if (result.status === 'OK')
          completeFunc(result)
        else
          errorFunc(result)
      })
      .catch(function (error) {
        console.log('error',error);
        errorFunc({ status: 'error', desc: error });
      })
  }

}

export default new CalendarStore()



// WEBPACK FOOTER //
// ./src/stores/CalendarStore.js